import { useEffect } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  useEffect(() => {
    document.title = "页面不存在 - 国模白露写真作品集";
  }, []);

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center px-4 py-24 text-center">
      <span className="pointer-events-none absolute select-none text-[8rem] font-black leading-none text-background-100 md:text-[14rem]">
        404
      </span>
      <div className="relative z-10 flex flex-col items-center">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-3xl text-primary-600">
          <i className="ri-emotion-sad-line" />
        </span>
        <h1 className="mt-6 text-2xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-3 max-w-md text-sm text-foreground-500">
          你访问的页面不存在或已被移动，返回首页继续浏览国模白露的模特写真作品集吧。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
          <Link
            to="/favorites"
            className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
          >
            <i className="ri-heart-3-line" />
            我的收藏
          </Link>
        </div>
      </div>
    </div>
  );
}